export abstract class FormDocumentBase {
  comment: string;
  fileDate: Date | null;
  fileName: string;
  fileSizeBytes: number;

  constructor() {
    this.comment = '';
    this.fileDate = null;
    this.fileName = '';
    this.fileSizeBytes = 0;
  }
}
